<template>
  <div class="text-center success-page">
    <div>
      <i class="icon-checkmark-circle text-success" style="font-size: 5rem;"></i>
    </div>
    <h1>{{ $t('dispute.success_title') }}</h1>
    <div>
      <p class="dispute-success" v-html="$t('dispute.success')"></p>
    </div>
    <div>
      <a href="/" class="btn btn-success btn-lg">
        {{ $t('dispute.back_to_home') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisputeSuccess'
};
</script>


<style scoped>
.success-page {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

h1 {
  color: #666;
  text-transform: none;
  font-weight: bold;
}

.dispute-success {
  color: #666;
  line-height: 1.75;
}
</style>
